import { render, staticRenderFns } from "./defaultRulesDialog.vue?vue&type=template&id=3023b228&"
import script from "./defaultRulesDialog.vue?vue&type=script&lang=js&"
export * from "./defaultRulesDialog.vue?vue&type=script&lang=js&"
import style0 from "./defaultRulesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports